import React from 'react'

import Layout from '../../components/BlogLayout'
import BlogRoll from '../../components/BlogRoll'
import HeroBlog from '../../components/HeroBlog'

export default class BlogIndexPage extends React.Component {
  render() {
    return (
      <Layout>
      <HeroBlog/>
        
        <section className="section">
          <div className="container" style={{display: 'flex',
  alignItems: 'center',  justifyContent: 'center',alignItems:'center',alignSelf:'center'}}>
           
              <BlogRoll />
            
          </div>
        </section>
      </Layout>
    )
  }
}
